/** Illustrative Calify booking card, shared by the landing and signup pages. */
export function BookingMockup() {
  const days = ["Lun", "Mar", "Mer", "Jeu", "Ven"];
  const slots = ["09:00", "10:30", "14:00", "15:30"];
  return (
    <div className="relative mx-auto w-full max-w-md">
      <div className="absolute -inset-4 -z-10 rounded-[2rem] bg-gradient-to-br from-[#C5D6C6] via-[#EEF3F0] to-white blur-2xl" />
      <div className="rounded-2xl border border-[#E3E8E5] bg-white p-6 shadow-2xl shadow-[#0B3022]/10">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0B3022] text-sm font-semibold text-white">
            CM
          </div>
          <div>
            <p className="text-sm font-semibold text-[#0B3022]">Camille Martin</p>
            <p className="text-xs text-[#5B6E63]">Consultation découverte · 30 min</p>
          </div>
        </div>
        <div className="mt-6 grid grid-cols-5 gap-2 text-center text-xs">
          {days.map((d, i) => (
            <div
              key={d}
              className={`rounded-lg py-2 ${i === 2 ? "bg-[#0B3022] font-semibold text-white" : "bg-[#F6F8F7] text-[#3D5247]"}`}>
              {d}
              <span className="block text-[13px] font-semibold">{12 + i}</span>
            </div>
          ))}
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2">
          {slots.map((s, i) => (
            <div
              key={s}
              className={`rounded-lg border py-2 text-center text-sm font-medium ${
                i === 1 ? "border-[#0B3022] bg-[#EEF3F0] text-[#0B3022]" : "border-[#E3E8E5] text-[#3D5247]"
              }`}>
              {s}
            </div>
          ))}
        </div>
        <div className="mt-5 rounded-lg bg-[#0B3022] py-2.5 text-center text-sm font-semibold text-white">
          Confirmer mercredi à 10:30
        </div>
      </div>
      <div className="absolute -bottom-6 -right-4 hidden items-center gap-2 rounded-xl border border-[#E3E8E5] bg-white px-4 py-3 shadow-lg sm:flex">
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#2F7D58] text-white">✓</span>
        <span className="text-xs">
          <span className="block font-semibold text-[#0B3022]">Rendez-vous confirmé</span>
          <span className="text-[#5B6E63]">Rappel envoyé 24 h avant</span>
        </span>
      </div>
    </div>
  );
}
